import { isDate } from '../type-guards';

/**
 * Converts a `Date` object to a local `YYYY-MM-DD` string.
 *
 * Unlike `toISOString()`, this version preserves the local calendar day by
 * adjusting for timezone offset before formatting.
 *
 * If the input is not a valid Date, an empty string is returned.
 *
 * @param date - A valid `Date` instance.
 * @returns The local date as a string in `YYYY-MM-DD` format.
 *
 * @example
 * toIsoDateString(new Date(2020, 0, 1)); // '2020-01-01'
 */
export function toIsoDateString(date: Date): string {
  if (!isDate(date)) return '';

  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  return date.toISOString().split('T')[0];
}
